<template>
  <v-card class="mt-5">
    <AppVCardTitle label="Vue générale"/>

    <AppVTextWithButton label="Défauts éventuels constatés " :image_url="images_url" />
    <v-card-text class="pt-0 pb-0">
      <v-textarea v-if="!value.hasAnyDefectsFound" v-model="value.defectsFound" placeholder="Commentaire" filled auto-grow rows="1"/>
    </v-card-text>

    <AppVTextWithButton label="Photo de la cuve *" image_url="/img/implementedForms/62b97ed722d02/tank.png"/>
    <v-card-text class="pt-0">
      <AppImageInput v-model="value.tank" placeholder="Image de la cuve" :rules="[v => !!v && v.length === 1]" @input="emitInput"/>
    </v-card-text>

    <AppVTextWithButton label="Photo du trou d'homme *" image_url="/img/implementedForms/62b97ed722d02/manhole.png"/>
    <v-card-text class="pt-0">
      <AppImageInput v-model="value.manhole" placeholder="Image du trou d'homme" :rules="[v => !!v && v.length === 1]" @input="emitInput"/>
    </v-card-text>

    <AppVTextWithButton label="Photo des éléments de tuyauterie *" image_url="/img/implementedForms/62b97ed722d02/piping.jpeg"/>
    <v-card-text class="pt-0">
      <AppImageInput v-model="value.piping" placeholder="Image des éléments de tuyauterie" :rules="[v => !!v && v.length === 1]" @input="emitInput"/>
    </v-card-text>
  </v-card>
</template>

<script>
import AppVCardTitle from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/VCardTitle";
import AppVTextWithButton from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/VTextWithButton";
import AppImageInput from "@/components/App/ImageInput.vue";

export default {
  name: "ControlOfTheElectricalCabinet",
  components: {
    AppVCardTitle,
    AppVTextWithButton,
    AppImageInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      images_url: ["/img/implementedForms/62b97ed722d02/detectedDefect.jpeg", "/img/implementedForms/62b97ed722d02/detectedDefect2.jpeg"],
    };
  },
  methods: {
    emitInput() {
      this.$emit("input", this.value);
    },
  },
};
</script>
